(ns ncr.sidebar.folders
  (:require
   [ncr.widgets.core :as w]
   [ncr.widgets.dropzone :as wdz]
   [ncr.etc.pf :as pf]
   [ncr.nsql :as nsql]
   [ncr.navigate :as n]
   [ncr.sidebar.common :as common]))

(defn c-folder [{:keys [on-drop-accepted drop-accepted?] :as props} {:keys [href label count] :as folder}]
  (let
    [{:keys [get-root-props is-drag-active]}
     (wdz/use-dropzone
       {:no-click true
        :on-drop-accepted
        (fn [files]
          (on-drop-accepted folder files))})]

    [common/c-sidebar-item
     (w/merge-props props
       {:href href
        :entry folder
        :inner-props
        (if drop-accepted?
          (w/merge-props props
            (get-root-props)
            {:class
             (when is-drag-active
               :ncr-m-drag-hover)})
          {:class :ncr-c-no-dropzone})})
     [pf/c-split
      [pf/c-split-item {:is-filled true}
       [:span {:style {:overflow-wrap :anywhere}} label]]

      (when (pos? count)
        [pf/c-split-item
         [pf/c-badge {:is-read true} count]])]]))

(defn model [{:keys [id name fragmentCount]}]
  (let [query (str "in:" (nsql/maybe-quote name))]
    {:id id :label name :count fragmentCount :query query
     :href (n/search-href query)}))